module.exports = __webpack_public_path__ + "static/media/icon-home.ed391f96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Stepper/assets/icon-home.svg
// module id = 1504
// module chunks = 193